import Vue from "vue";

export default {
  getScoreCardReport(_, reportParams) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/appraisals/reports`, reportParams)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
